<template>
  <div>
    <Banner id="5000" width="1200" height="org" />
    <BrandsIcons :pageCustom="[[200, 1], [576,2], [768, 3], [1024, 4]]" :speed="3000" />
    <div class="container">
      <div class="content-wrapper">
        <div class="welcome-page-container">
          <div class="row">
            <div v-for="(category, index) in categories" class="col-4 col-lg-3">
              <div class="category-block" @click="selected(category)">
                <div class="category-block-panel" v-if="category.imageList.length > 0">
                  <img :src="category.imageList[0]" />
                </div>
                <div class="category-block-panel" :class="colors[index % 20]" v-else></div>
                <p>{{ category.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WelcomeIcons from "redbay-b2b-categories/src/CategoriesIconsWelcome.vue";
import BrandsIcons from "./../brands/src/BrandCarousel.vue";
import Banner from "./../banners/src/BannerCarousel.vue";
import { ContactForm, BannerOpacity } from "../RedbayComponents";

export default {
  name: "WelcomePage",

  computed: {
    ...mapState({
      categories: state =>
        state.categories.list.sort((a, b) => a.name.localeCompare(b.name))
    })
  },

  data() {
    return {
      colors: [
        "block-turquoise",
        "block-green-sea",
        "block-emerald",
        "block-nephritis",
        "block-peter-river",
        "block-belize-hole",
        "block-amethyst",
        "block-wisteria",
        "block-wet-asphalt",
        "block-midnight-blue",
        "block-sun-flower",
        "block-orange",
        "block-carrot",
        "block-pumpkin",
        "block-alizarin",
        "block-pomegranate",
        "block-clouds",
        "block-silver",
        "block-concrete",
        "block-asbestos"
      ]
    };
  },

  components: {
    WelcomeIcons,
    BrandsIcons,
    Banner,
    ContactForm
  },

  methods: {
    selected(category) {
      this.$store.dispatch("categories/selected", {
        category: category,
        top: true
      });
      this.$emit("selected");
      this.$router.replace({ name: "searchPage" });
    }
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.$config.get("welcomePage.enabled")) {
      this.$router.replace({ name: "searchPage" });
    }

    this.$store.dispatch("search/clear");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/WelcomePage.vue